module.exports = __webpack_public_path__ + "img/lt_newly_build.603c7ba6.png";